module.exports = __webpack_public_path__ + "img/huntsville.b832c3b0.png";